import { ShipBobTelemetry } from '@shipbob/telemetry';
import { ENV } from '@src/env';

let telemetry;
const includedHosts = ['toolbob', 'merchantapp'];

export function setupTelemetry(options = {}) {
  if (ENV.COLLECT_ANALYTICS && ENV.APPINSIGHTS_CONNECTIONSTRING) {
    const { host = false } = options;
    const { hostname } = window.location;
    let mfeHost = 'none';
    let cloudRoleName = 'DesignSystem-standAlone';

    if (host) {
      const sanitizedHost = includedHosts.find((includedHost) => host.trim().toLowerCase() === includedHost);

      if (sanitizedHost) {
        mfeHost = sanitizedHost;
        cloudRoleName = `DesignSystem-${sanitizedHost}`;
      }
    }

    if (hostname === 'localhost') {
      cloudRoleName = `DesignSystem-local`;
    }

    telemetry = new ShipBobTelemetry({
      connectionString: ENV.APPINSIGHTS_CONNECTIONSTRING,
      tags: {
        'ai.cloud.role': cloudRoleName,
      },
      customData: {
        dsOptions: {
          standAlone: options.standAlone,
          hostPath: options.hostPath,
          hostLocale: options.hostLocale,
          mfeHost,
          hostname,
        },
      },
      config: {
        // track no network calls
        disableFetchTracking: true,
        disableAjaxTracking: true,
        loggingLevelConsole: 2,
        loggingLevelTelemetry: 2,
      },
    });
  }
}

export function getTelemetryInstance() {
  return telemetry;
}

export const telemetryInclusionList = [
  // using primevue only
  'SbAccordion',
  'SbStepper',
  'SbSelect',
  'SbDataTable',
  'SbDatePicker',

  // deprecated components
  'SbDropdown',

  // next versions
  'SbActionList',
  'SbButton',
  'SbCheckbox',
  'SbChip',
  'SbFilterWrapper',
  'SbModal',
  'SbNumberInput',
  'SbPage',
  'SbPanel',
  'SbRadioButton',
  'SbTabs',
  'SbTabsList',
  'SbTextArea',
  'SbTextInput',
  'SbTimeline',
];
